import { render } from "./ButtonComponent.vue?vue&type=template&id=184e295c&scoped=true&ts=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts"

import "./ButtonComponent.vue?vue&type=style&index=0&id=184e295c&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e295c"]])

export default __exports__